<template>
  <section class="container">
     <div class="row">
        <div class="col-md-12">
          <h4 class="g-mb-10">Site Information</h4>
        </div>
      </div>

      <div class="row g-bg-secondary g-pa-20 g-mb-5 g-mt-5 g-brd-around g-brd-gray-light-v4">

        <div class="col-md-12">
          <dl class="row">
              <dt class="col-sm-3">Project Name</dt>
              <dd class="col-sm-9">{{ safetyPlan.projectName }}</dd>
            </dl>
          <dl class="row">
              <dt class="col-sm-3">Date</dt>
              <dd class="col-sm-9">{{ formatDate(safetyPlan.planDate) }} - {{ formatDate(safetyPlan.planDateEnd) }}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Farm</dt>
              <dd class="col-sm-9">{{ safetyPlan.farmName }}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Have all subcontractors been pre-qualified by the safety team?</dt>
              <dd class="col-sm-9">{{ safetyPlan.contractorsInductedInd ? 'Yes' : 'No' }}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Contractor</dt>
              <dd class="col-sm-9">{{ safetyPlan.subContractor !== null ? safetyPlan.subContractor : 'None' }}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Person in Charge</dt>
              <dd class="col-sm-9">{{ safetyPlan.personInCharge }}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Person in Charge Mobile Number</dt>
              <dd class="col-sm-9">{{ safetyPlan.personInChargeNumber }}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Does this work require WorkSafe notification?</dt>
              <dd class="col-sm-9">{{ safetyPlan.workSafeNotification ? 'Yes' : 'No' }}</dd>
            </dl>
        </div>

      </div>

      <div class="row">
        <div class="col-md-12">
          <h4 class="g-mb-10 g-mt-10">Emergency</h4>
        </div>
      </div>

      <div class="row g-bg-secondary g-pa-20 g-mb-5 g-mt-5 g-brd-around g-brd-gray-light-v4">

        <div class="col-md-6" v-if="safetyPlan.emergencyContact !== null">
          <dl class="row">
            <dt class="col-sm-4">Emergency contact name</dt>
            <dd class="col-sm-8">{{ safetyPlan.emergencyContact }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.emergencyContactNumber !== null">
          <dl class="row">
            <dt class="col-sm-4">Emergency contact number</dt>
            <dd class="col-sm-8">{{ safetyPlan.emergencyContactNumber }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.medicalEmergencyContact !== null">
          <dl class="row">
            <dt class="col-sm-4">Medical Emergency contact name</dt>
            <dd class="col-sm-8">{{ safetyPlan.medicalEmergencyContact }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.medicalEmergencyContactNumber !== null">
          <dl class="row">
            <dt class="col-sm-4">Medical Emergency contact number</dt>
            <dd class="col-sm-8">{{ safetyPlan.medicalEmergencyContactNumber }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.firstAidKitLocation !== null">
          <dl class="row">
            <dt class="col-sm-4">First aid kit location</dt>
            <dd class="col-sm-8">{{ safetyPlan.firstAidKitLocation }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.fireEquipmentLocation !== null">
          <dl class="row">
            <dt class="col-sm-4">Fire equipment location</dt>
            <dd class="col-sm-8">{{ safetyPlan.fireEquipmentLocation }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.hospitalLocation !== null">
          <dl class="row">
            <dt class="col-sm-4">Hospital/Clinic location</dt>
            <dd class="col-sm-8">{{ safetyPlan.hospitalLocation }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.assemblyPoint !== null">
          <dl class="row">
            <dt class="col-sm-4">Assembly point</dt>
            <dd class="col-sm-8">{{ safetyPlan.assemblyPoint }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.firstAider1 !== null">
          <dl class="row">
            <dt class="col-sm-4">First aider(s)</dt>
            <dd class="col-sm-8">{{ safetyPlan.firstAider1 }}<br> {{ safetyPlan.firstAider2 }}</dd>
          </dl>
        </div>
        <div class="col-md-6" v-if="safetyPlan.otherInformation !== null">
          <dl class="row">
            <dt class="col-sm-4">Other information</dt>
            <dd class="col-sm-8">{{ safetyPlan.otherInformation }}</dd>
          </dl>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4 class="g-mb-10 g-mt-10">High-risk work categories</h4>
        </div>
      </div>
      <div class="row g-bg-secondary g-pa-20 g-mb-5 g-mt-5 g-brd-around g-brd-gray-light-v4">
        <div class="col-md-12">
          <ul>
            <li v-for="workingType in workingTypes" v-bind:key="workingType">{{ workingType }}</li>
          </ul>
        </div>
      </div>

      <div class="row" v-if="safetyPlan.projectPlan !== null">
        <div class="col-md-12">
          <h4 class="g-mb-10 g-mt-10">Plan for the project</h4>
        </div>
      </div>
      <div class="row g-bg-secondary g-pa-20 g-mb-5 g-mt-5 g-brd-around g-brd-gray-light-v4" v-if="safetyPlan.projectPlan !== null">

        <div class="col-md-12">
          <p>
            {{ safetyPlan.projectPlan }}
          </p>

        </div>
      </div>
      <div class="row" v-if="safetyPlan.siteImage !== null">
        <div class="col-md-12">
          <h4 class="g-mb-10 g-mt-10">Site Sketch, Plan Map or Image</h4>
        </div>
      </div>
      <div class="row g-bg-secondary g-pa-20 g-mb-5 g-mt-5 g-brd-around g-brd-gray-light-v4" v-if="safetyPlan.siteImage !== null">

        <div class="col-md-12">
          <img v-bind:src="safetyPlan.siteImage" class="img-fluid">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4 class="g-mb-10 g-mt-10">Tasks, Risks and Controls</h4>
        </div>
      </div>
      <div class="row g-bg-secondary g-pa-20 g-mb-5 g-mt-5 g-brd-around g-brd-gray-light-v4" v-for="task in safetyPlan.tasks" v-bind:key="task.id">

        <div class="col-md-6">
          <dl class="row">
            <dt class="col-sm-4">Task.. What am I doing?</dt>
            <dd class="col-sm-8">{{ task.task }}</dd>
          </dl>
        </div>
        <div class="col-md-6">
          <dl class="row">
            <dt class="col-sm-4">Risk.. What could go wrong?</dt>
            <dd class="col-sm-8">{{ task.risk }}</dd>
          </dl>
        </div>
        <div class="col-md-6">
          <dl class="row">
            <dt class="col-sm-4">HSW</dt>
            <dd class="col-sm-8">{{ task.hswInd ? 'Yes' : 'No' }}</dd>
          </dl>
        </div>
        <div class="col-md-6">
          <dl class="row">
            <dt class="col-sm-4">E&amp;S</dt>
            <dd class="col-sm-8">{{ task.esInd ? 'Yes' : 'No' }}</dd>
          </dl>
        </div>
        <div class="col-md-6">
          <dl class="row">
            <dt class="col-sm-4">Controls.. How can I do it safely?</dt>
            <dd class="col-sm-8">{{ task.control }}</dd>
          </dl>
        </div>

          <!-- <table class="table table-bordered">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="task in safetyPlan.tasks" v-bind:key="task.id">
              <td></td>
              <td>{{ task.risk }}</td>
              <td style="background-color: rgb(103, 182, 211);"></td>
              <td style="background-color: #54c348;"></td>
              <td></td>
            </tr>
            </tbody>
          </table> -->
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4 class="g-mb-10 g-mt-10">Minimum site and Task-based PPE</h4>
        </div>
      </div>
      <div class="row">

        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-hiviz.png" class="img-fluid">
              <p>Hi Viz</p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeHighViz" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-glasses.png" class="img-fluid">
              <p>Safety Glasses</p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeSafetyGlasses" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>

        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-boots.png" class="img-fluid">
              <p>Steel toe cap boots</p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeSteelToeCapBoots" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-respirator.png" class="img-fluid">
              <p>Respirator</p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeRespirator" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-gloves.png" class="img-fluid">
              <p>Gloves</p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeGloves" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-overalls.png" class="img-fluid">
              <p>Overalls</p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeOveralls" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-hat.png" class="img-fluid">
              <p>Hard Hat </p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeHardHat" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center">
            <div class="text-center">
              <img src="/media/website/icons/safetychecklist-earmuffs.png" class="img-fluid">
              <p>Ear Muffs</p>
            </div>
            <div class="d-flex justify-content-center">
              <span v-if="safetyPlan.ppeEarMuffs" class="align-self-center g-pa-15 g-ml-15 fa fa-check g-color-primary" style="border: #54c348 2px solid;"></span><span v-else style="border: #54c348 2px solid;" class="align-self-center g-pa-15 g-ml-15 fa fa-close g-color-red"></span>
            </div>
          </div>
        </div>
      </div>

  </section>
</template>

<script>

import SafetyPlanService from '../services/safetyplanservice';
import { computed, onMounted, ref } from '@vue/runtime-core';
import DateUtils from '../utils/dateutils';

export default {
  name: 'App',
  components: {

  },
  setup() {
    const safetyPlanService = SafetyPlanService;
    const safetyPlan = ref({ id: 0 });

    const loadSafetyPlan = async (safetyPlanId) => {
      safetyPlan.value = await safetyPlanService.fetchSafetyPlan(safetyPlanId);
    }

    const formatDate = (date) => {
      return DateUtils.getFormattedDate(date);
    }

    const workingTypes = computed(() => {
      return safetyPlan.value.workingType.split('||');
    });

    onMounted(async () => {
      const safetyPlanId = window.hasOwnProperty("id")
          ? window.id
          : null;

      await loadSafetyPlan(safetyPlanId);
    });


    return {
      safetyPlan,
      formatDate,
      workingTypes
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
